<template>
  <div class="user-admin">
    <b-card-body>
      <b-form submit="save">
        <input id="user-id" type="hidden" v-model="userprofile.id" />
        <b-row class="rowUsername">
          <b-col md="6" sm="12">
            <b-form-group
              :key = "0"
              id="userprofile-description"
              :label="$t('descricao-0')"
              label-for="userprofile-description"
              v-if="userprofile.id == 0"
            >
              <b-form-input
                class="input-pentagro"
                id="userprofile-description"
                type="text"
                name="validatedDescription"
                v-model="userprofile.description"
                aria-describedby="validateDescription-feedback"
                :data-vv-as="$t('descricao-2')"
                :placeholder="$t('informe-a-descricao-do-perfil')"
                v-if="userprofile.id == 0"
              />
            </b-form-group>
            <div v-else class="txtLogin">
              <b>{{ $t('descricao-userprofile-description', [userprofile.description]) }}</b>
            </div>
          </b-col>

          <b-col md="2" sm="2" class="rowToken">

            <label for="tokenExpiration"
            :title="$t('tempo-de-token-1')"
            >{{ $t('tempo-de-token') }}</label>
            <b-form-spinbutton
              class="spinbutton-pentagro"
              id="tokenExpiration"
              v-model="userprofile.tokenExpiration"
              min="1"
              :max="this.tokenMaxTime"
              step="1"
            ></b-form-spinbutton>
          </b-col>
          <b-col class="mb-3" md="2" sm="2" v-if="isSearchLimited">
            <label for="limitSearchAdherence">{{ $t('limit-adherence-search') }}</label>
            <section class="limitSearchContainer">
              <button type="button" @click="customChangeSearchLimit('down')">
                <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="dash" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-dash b-icon bi"><g transform="translate(8 8) scale(1.25 1.25) translate(-8 -8)"><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"></path></g></svg>
              </button>
              <input
                id="limitSearchAdherence"
                v-model="searchLimitInterval"
                min="1"
                max="365"
                type="number"
                />
              <button type="button" @click="customChangeSearchLimit('up')">
                <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="plus" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-plus b-icon bi"><g transform="translate(8 8) scale(1.25 1.25) translate(-8 -8)"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path></g></svg>
              </button>
            </section>
          </b-col>
          <b-col>
            <b-form-checkbox
              v-model="userprofile.receiveAutonomousWarning"
              name="check-button-receiveAutonomousWarning"
              switch
            >
              {{ $t('receber-alertas-0') }} </b-form-checkbox>
            <b-form-checkbox
              v-model="userprofile.handleOccurrences"
              name="check-button-handleOccurrences"
              switch
            >
              {{ $t('tratar-ocorrencias-0') }} </b-form-checkbox>
          </b-col>
        </b-row>

        <span v-if="isSearchLimited && userprofile.profileId == 1" id="warningLimitSearch">*Aviso: Usuários com o perfil 'Administrativo' não terão suas buscas limitadas pela permissão 'Limitar Buscas de Aderências'.</span>
        <hr />

        <b-row>
         
            <p class="ml-3">
              {{ $t('permissoes') }} <img
                src="@/assets/allPermissionsTrue.png"
                class="iconPermission"
                :alt="$t('habilitar-todas-as-permissoes')"
                :title="$t('habilitar-todas-as-permissoes')"
                @click="changeAllPemissions(true)"
              />
              <img
                src="@/assets/allPermissionsFalse.png"
                class="iconPermission"
                :alt="$t('desabilitar-todas-as-permissoes')"
                :title="$t('desabilitar-todas-as-permissoes')"
                @click="changeAllPemissions(false)"
              />
            </p>

            <b-card-body class="containerScreen">
              <b-row  
                class="boxContainer"
                xl="3" lg="6" md="6" sm="6" 
                v-for="area in this.areasList" :key="area"
                >
          
                  <b-col  :key="area">
                    <p>
                      <b>{{ area }}:</b>
                    </p>
                    <b-card class="boxPermission boxAdmPerm">
                      <div>
                        <template
                          v-for="(
                            value, name, index
                          ) in userprofile.jsonPermissions"
                        >
                        <b-form-checkbox
                          :key="name + index"
                          v-if="value.area == area"
                          v-model="value.allowed"
                          @change="(event) => ChangePermissionStatus(event, name)"
                          switch
                        >
                          {{ value.permission }}
                        </b-form-checkbox>
                        </template>
                      </div>
                    </b-card>
                  </b-col>
              </b-row>
            </b-card-body>
 
        </b-row>

        <b-row class="groupButton mb-3">
          <div>
            <img
            v-if="!loadingReport"
              style="margin-left: 30px; height=38px"
              @click="save"
              id="search-button"
              src="@/assets/salvar.png"
              :title="$t('salvar')"
              :alt="$t('salvar')"
            />
            <span
              v-else
              class="spinner-border spinner-border-sm spinnerConfig"
              role="status"
              aria-hidden="true"
            ></span> 
            <img
              src="@/assets/cancel.png"
              :alt="$t('cancelar')"
              style="margin-left: 30px; height=38px; margin-bottom: 5px"
              :title="$t('cancelar')"
              @click="$bvModal.show('confirmProfileFormRestore')"
            />
          </div>
          <!-- </b-col> -->
        </b-row>
      </b-form>     

      <b-card>
        <b-table
          hover
          responsive
          striped
          small
          :items="userProfiles"
          :fields="fields"
          sort-by="id"
        >
          <template v-slot:cell(actions)="row">
            <img
              src="@/assets/editarusuario.png"
              :alt="$t('editar-perfil')"
              style="max-height: 25px"
              :title="$t('editar-perfil-0')"
              @click="loadProfile(row.item.id)"
            />
          </template>
        </b-table>
      </b-card>
    </b-card-body>  

     <b-modal
        id="confirmProfileFormRestore"
        ok-variant=danger
        :title="$t('atencao')"
        :ok-title="$t('yes')"
        :cancel-title="$t('no')"
        @ok="resetProfile"
        >{{ $t('confirma-o-descarte-das-alteracoes-0') }}
      </b-modal>
  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "ProfileAdmin",
  watch: {
    "searchLimitInterval"(value){
      this.searchLimitInterval = Number(value) > 365 ? 365 : value = "" || Number(value) < 1 ? 1 : value;
    }
  },

  data() {
    return {
      loadingReport: false,
      mode: "save",
      saved: false,
      userprofileTemp: {},
      userprofile: {
        id: 0,
        tokenExpiration: 1,
        description: "",
        system: null,
        productionUnitId: 1,
      },
      areasList: [],
      userProfiles: [],
      fields: [
        { key: "id", label: this.$t('codigo'), sortable: true },
        { key: "description", label: this.$t('descricao-0'), sortable: true },
        { key: "actions", label: this.$t('acoes-1') },
      ],
      isSearchLimited:false,
      searchLimitInterval:365,
    };
  },

  methods: {
    customChangeSearchLimit(operation){
      if(operation != undefined && operation != ""){
        if(operation == "down") this.searchLimitInterval = Number(this.searchLimitInterval) - 1;
        else if( operation == "up") this.searchLimitInterval = Number(this.searchLimitInterval) + 1; 
      }
    },

    async loadProfile(profileId, mode = "save") {
      const url = `${urlMainAPI}/getuserprofilebyid/${profileId}`;
      await axios
        .get(url)
        .then((res) => {
          this.userprofile = res.data;
          this.userprofile.system = this.system[0];
          this.userprofile.jsonPermissions = JSON.parse(
            this.userprofile.jsonPermissions
          );

          if(this.userprofile.jsonPermissions.limitarbuscaaderencias && this.userprofile.jsonPermissions.limitarbuscaaderencias.allowed && this.userprofile.jsonPermissions.limitarbuscaaderencias.allowed == true)
              this.isSearchLimited = true;

          this.searchLimitInterval = this.userprofile.searchLimit;

          this.userprofileTemp = JSON.parse(JSON.stringify(this.userprofile))

          let distinctList = new Set();
          for (let key in this.userprofile.jsonPermissions) {
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!this.userprofile.jsonPermissions[key].area) {
              distinctList.add(this.userprofile.jsonPermissions[key].area);
            }
          }
          this.areasList = Array.from(distinctList).sort();

          this.mode = mode;
          if (this.userprofile.id > 0) {
            defaultSuccess(this.$t('perfil-carregado'));
          }
        })
        .catch();
    },

    save() {
      this.loadingReport = true;

      this.userprofile.description = this.userprofile.description.trim()
      if(!this.userprofile.description){
        showError(this.$t('nao-e-possivel-criar-um-perfil-sem-descricao'))
        setTimeout(() => {
          this.loadingReport = false;
        }, 1000);
        return
      }
      this.userprofile.productionUnitId = parseInt(
        this.$store.state.user.UnitId
      );

      if(this.userprofile.jsonPermissions.limitarbuscaaderencias && this.userprofile.jsonPermissions.limitarbuscaaderencias.allowed && this.userprofile.jsonPermissions.limitarbuscaaderencias.allowed == true)
        this.userprofile.searchLimit = this.searchLimitInterval;

      axios.post(`${urlMainAPI}/saveuserprofile`, this.userprofile)
        .then((res) => {
          defaultSuccess(res.data);          
          setTimeout(() => {
          this.loadingReport = false;
        }, 1000);
          this.resetProfile();
        })
        .catch();
        
    },

    changeAllPemissions(status) {
      Object.keys(this.userprofile.jsonPermissions).forEach(
        (item) => {
          this.userprofile.jsonPermissions[item].allowed = status

          if(this.userprofile.jsonPermissions[item].action == "limitarbuscaaderencias"){
            this.isSearchLimited = status
          }
        }
      );
    },

    ChangePermissionStatus(event, name) {
      this.userprofile.jsonPermissions[name].allowed = event;

      if(this.userprofile.jsonPermissions[name] && this.userprofile.jsonPermissions[name].action == "limitarbuscaaderencias"){
        this.isSearchLimited = event;
      }
    },

    loadProfiles() {
      const url = `${urlMainAPI}/getprofiles`;
      axios
        .get(url)
        .then((res) => {
          this.userProfiles = res.data;
        })
        .catch();
    },

    resetProfile() {
      this.loadProfile(0);
      this.loadProfiles();
    },

    resetChanges(){
      this.userprofile = this.userprofileTemp
    }
  },

  created() {
    this.system = this.$store.state.system;
    this.tokenMaxTime = this.$store.state.tokenMaxTime;
    this.loadProfile(0);
    this.loadProfiles();
  },

  beforeDestroy() { this.$validator.pause() },
};
</script>

<style scoped>
.iconPermission {
  max-height: 45px;
  margin: 0px 5px 0px 0px;
  cursor: pointer;
}

 .btAllPermission {
  margin-left: 10px;
  margin-right: 10px;
}

.boxPermission {
  min-width: 290px;
  height: 320px;
  overflow: auto;
  margin: 10px 0px;
}

.groupButton {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
}

.groupButton img {
  cursor: pointer;
}

.rowUsername {
  align-items: center;
  margin-bottom: 20px;
}

.rowToken {
  align-items: center;
  margin-bottom: 15px;
}

.disable {
  color: rgb(178, 64, 0);
}

img {
  max-height: 45px;
}

.txtLogin {
  font-size: 140%;
}

@media only screen and (max-width: 768px) {
  .boxAdmPerm {
    min-height: 180px;
  }

  .txtLogin {
    margin-bottom: 20px;
  }
}

.boxContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; 
  margin-right: 4px;
  margin-left: 1px; 
  flex-direction: column;
  padding: 0.5rem;
  width: 380px; 
}

.containerScreen{
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    padding: 10p;
    box-shadow: 0 0 3px #0003;
    width: 100%;

}

.spinnerConfig {
  width: 1.5rem; 
  height: 1.5rem;
  margin-left: 10px;
  color: #ff5f00;
}

.groupButton {
  margin: 15px;
}


#limitSearchAdherence{
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  width: 100%;
  height: 100%;
  border: none;
}

#limitSearchAdherence::-webkit-outer-spin-button,
#limitSearchAdherence::-webkit-inner-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

.limitSearchContainer{
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #ff5f00;
  border-radius: 3px;
  color: #495057;
}

.limitSearchContainer input:focus{
  
  border: none !important;
  box-shadow: none !important;
}

.limitSearchContainer:focus-within {
  box-shadow: 0px 0px 5px #ff5f00;
}

.limitSearchContainer button{
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0 8px;
}

.limitSearchContainer button:first-child{
  border-right: 1px solid #dee2e6;
}
.limitSearchContainer button:last-child{
  border-left: 1px solid #dee2e6;
}

#warningLimitSearch{
  font-size: 0.9rem;
  color: #ff8800;
}
</style>